export default __webpack_public_path__ + "static/media/fallback_project.88448ee5.png";